<div class="dx-page-content-wrapper">
  <!-- This class doesn't seem to do anything and references a very old name -->
  <ea-global-header
    class="bl-print-hide"
    *ngIf="!hideHeader"
    id="global-header"
    [logoSrc]="lenderConfig?.lenderLogoUrl"
    [logoAlt]="lenderConfig?.lenderName + ' logo'"
    logoHref="/user/dashboard"
    [hideSideNavCtrl]="true"
  >
    <!-- User dropdown -->
    <ng-container *ngIf="showHeaderUserDropdown()">
      <cu-user-dropdown class="bl-display--flex bl-margin-left--auto bl-height--100 bl-align-items--center"> </cu-user-dropdown>
    </ng-container>
  </ea-global-header>

  <main role="main" class="dx-page-content bl-bg-color--snow">
    <router-outlet></router-outlet>
    <dx-workflow-loader />
    <div class="id-verify-holder hidden" id="id-verify-anchor"></div>
  </main>

  <ng-container *ngIf="!hideFooter">
    <ng-container *ngIf="!frame; else iframeFooter">
      <arcdx-footer class="bl-print-hide" [copyright]="lenderConfig?.copyright" id="arcdx-footer">
        <ul class="bl-display--flex bl-flex-flow--wrap">
          <!-- Lender links -->
          @if(lenderConfig?.footerLinks?.enableCustomLinks){
          <li *ngFor="let link of lenderConfig.footerLinks?.links; let i = index" class="bl-display--flex">
            <a [href]="link.route" id="custom-footer-link-{{ i }}" target="_blank" rel="noopener"
              class="bl-text-style--secondary-text-1 bl-font-color--base bl-text-decoration--none custom-footer-link">{{
              link.label }}</a>
            <span aria-hidden="true" class="bl-margin-x--8 bl-font-color--silver">|</span>
          </li>
          }
          <!-- Origence legal link -->
          <li>
            <ng-container *ngTemplateOutlet="origenceLegalLink"></ng-container>
          </li>
          <!-- Contact us toggle -->
          @if(lenderConfig?.contacts && lenderConfig?.footerLinks?.enableContactUsPanel){
          <li class="bl-display--flex">
            <span aria-hidden="true" class="bl-margin-x--8 bl-font-color--silver">|</span>
            <button id="contact-us-panel" (click)="showContactUsPanel = true"
              class="bl-text-style--secondary-text-1 bl-font-color--base bl-hover-text-decoration--underline bl-text-decoration--none">
              {{ 'appComponent/contact' | dictionary }}
            </button>
          </li>
          }
        </ul>

        <!-- Associations -->
        <section
          footer-secondary-content
          *ngIf="lenderConfig?.businessAssociations"
          [ngStyle]="{ width: lenderConfig?.businessAssociations?.length * 100 + 'px' }"
          class="bl-display--flex bl-flex-flow--wrap bl-margin-top--8 bl-margin-top-md--0 associations-container"
        >
          <a
            *ngFor="let item of activeBusinessAssociations; let firstLink = first; let i = index"
            id="association-{{ i }}"
            [href]="item.businessUrl"
            target="_blank"
            class="bl-margin-bottom--8"
            [ngClass]="firstLink ? 'bl-padding-left--0' : 'bl-padding-left--16'"
          >
            <img [src]="item.imageUrl" [alt]="item.name" />
          </a>
        </section>
      </arcdx-footer>
    </ng-container>

    <!-- frame slim footer -->
    <ng-template #iframeFooter>
      <footer id="frame-footer" class="bl-text-align--center bl-padding--16 bl-border-top">
        <ng-container *ngTemplateOutlet="origenceLegalLink; context: { frame: false }"></ng-container>
      </footer>
    </ng-template>

    <!-- Origence legal link template -->
    <ng-template #origenceLegalLink>
      <a
        href="/terms-and-policy{{ frame ? '?frame=yes' : '' }}"
        id="footer-origence-legal-link"
        target="_blank"
        rel="noopener"
        class="bl-text-style--secondary-text-1 bl-font-color--base bl-text-decoration--none"
        >{{ 'appComponent/origenceTerms' | dictionary }}</a
      >
    </ng-template>
  </ng-container>
</div>


<!-- Contact us panel -->
<ea-slide-in-panel
  [(isSlidePanelVisible)]="showContactUsPanel"
  [slidePanelTitle]="'Contact Us'"
  class="third-panel"
  id="contact-us-slide-panel"
>
  <section *ngFor="let contact of lenderConfig?.contacts" class="bl-margin-top--16">
    <div *ngIf="contact?.value" class="bl-display--flex">
      <!-- contact type icon -->
      <span *ngIf="contact?.type" class="bl-display--inline-block">
        <i
          class="bl-margin-right--16 bl-margin-top--4"
          [class.cu-phone-call]="contact?.type.toLowerCase() === 'phone'"
          [class.cu-mail]="contact?.type.toLowerCase() === 'email'"
          [class.cu-link]="contact?.type.toLowerCase() === 'url'"
        >
        </i>
      </span>
      <!-- contact info -->
      <p class="bl-word-break--break-all bl-margin-bottom--0">
        <span *ngIf="contact?.description" class="bl-text-style--default-text-2 bl-display--block">{{
          contact.description
        }}</span>
        <a
          *ngIf="contact?.type && isValidContactType(contact.type)"
          [href]="generateContactUrl(contact.type, contact.value)"
          target="_blank"
          rel="noopener"
          class="bl-display--inline-block bl-text-decoration--none bl-word-break--break-word"
        >
          <span
            *ngIf="contact.type !== 'url' || (contact.type === 'url' && !contact.additionalValue)"
            class="bl-margin-right--8"
            [innerHTML]="contact?.value"
          >
          </span>
          <ng-container *ngIf="contact?.additionalValue">{{ contact.additionalValue }}</ng-container>
        </a>
      </p>
    </div>
  </section>
</ea-slide-in-panel>

<ea-modal
  [modalTitle]="'Showing Session Modal'"
  [(isModalVisible)]="showUserSession"
  [modalSmall]="true"
  openModalElementId="showing-session-modal"
  [hideModalHeader]="true"
  id="showing-session-modal"
  tabindex="0"
>
  <div class="ng-content bl-text-align--center bl-margin-x--16 bl-margin-y--24">
    <cu-user-session *ngIf="showUserSession" (continueClick)="continueSession()"></cu-user-session>
  </div>
</ea-modal>
